import Axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment'

export const LiquidacionesServices = {
    api: {
        async getAll(filter) {
            return Axios.get('liquidaciones', {params: filter})
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async save(liquidaciones) {
            return Axios.post('liquidaciones', liquidaciones)
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async validarImportacion(liquidaciones) {
            return Axios.post('liquidaciones/validar-importacion', liquidaciones)
                .then(response => response.data)
        },
        async find(id) {
            return Axios.get('liquidaciones/' + id)
                .then((response) => { return response.data })
                .catch((error) => { throw error })
        },
        async delete(liquidacion) {
            return Axios.delete('liquidaciones/' + liquidacion.id)
                .then((response) => {
                    return response.data
                })
                .catch((error) => {
                    throw error
                })
        },
    },
    //DATA TABLES
    headers() {
        const header = [{ value: '#', sortable: 'numero' }, { value: 'Liquidacion', sortable: 'tipo_liquidacion' }, { value: 'Recibos', sortable: false }, { value: 'Total', sortable: 'total' }, { value: 'Usuario', sortable: false }]
        return header;
    },
    body() {
        const body = [{
                class: 'w-100',
                data: [{ value: 'numero', class: 'text-primary', label: '#' }]
            },
            {
                class: 'important',
                data: [
                    { value: 'tipo_liquidacion', class: 'text-secondary text-small' },
                    { value: 'periodo', class: 'text-bold' },
                ]
            },
            {
                class: 'w-100',
                data: [{ value: 'count_recibos', label: 'Cant. recibos' }]
            },
            {
                class: 'w-100',
                data: [{ value: 'total', label: 'Total liquidado', class: 'text-success', mutator: (value) => { return this.numberFormat(value) } }]
            },
            {
                class: 'w-100',
                data: [{ value: 'user.persona.nombre', label: 'Cargado por' }]
            },
        ]
        return body
    },
    dataList() {
        return [
            { name: "descripcion", class: "" },
            { name: "gerente.nombre", class: "text-secondary" },
        ]
    },
    //FROM EXCEL
    //LIQUIDACION
    findOrNewLiquidacion(fila, liquidaciones) {
        let liquidacion = liquidaciones.find(
            (liquidacion) => liquidacion.numero == parseInt(fila.cidliq)
        );
        if (liquidacion == null || liquidacion == undefined) {
            liquidacion = this.newLiquidacion(fila)
            liquidaciones.push(liquidacion)
        }
        return liquidacion
    },
    newLiquidacion(fila) {
        let liquidacion = {}
        liquidacion.numero = parseInt(fila.cidliq)
        liquidacion.periodo = (fila.cdescrip || fila._desc_liq).replace('SUELDOS ', '').replace('SUELDO ', '');
        liquidacion.tipo = fila._cper_liq
            ? fila._cper_liq.toUpperCase()
            : this.tiposLiquidacion.find(tipo => (tipo.Id == fila.cpepa.substr(0, 1))).Periodo.toUpperCase();
        liquidacion.recibos = []
        return liquidacion
    },
    //RECIBOS
    findOrNewRecibo(fila, recibos, personas) {
        let recibo = recibos.find(
            (recibo) => recibo.numero_legajo == parseInt(fila.legaj)
        )
        if (recibo == null) {
            recibo = this.newRecibo(fila, personas)
            recibos.push(recibo)
        }
        return recibo
    },
    newRecibo(fila, personas) {
        let recibo = {}
        let persona = personas.find((persona) => {
            if (persona.numero_legajo == parseInt(fila.legaj)) {
                return true
            }
            return false
        });
        if (persona) {
            recibo.persona_id = persona.id
            recibo.persona = persona
            recibo.categoria = `${persona.categoria.abreviatura} - ${persona.categoria.descripcion}`
            recibo.gerencia = persona.gerencia.descripcion
            recibo.area = persona.area.descripcion
            recibo.sucursal = persona.sucursal.descripcion
            recibo.obra_social = `${persona.obra_social.codem} ${persona.obra_social.descripcion}`
            recibo.sueldo_basico = `${persona.categoria.total}`
        } else {
            throw `El legajo ${fila.legaj} no se encuentra en la base de datos`
                // recibo.persona_id = 0
                // recibo.persona = null
                // recibo.categoria = '-'
                // recibo.gerencia = '-'
                // recibo.area = '-'
                // recibo.sucursal = '-'
                // recibo.obra_social = '-'
        }
        recibo.numero_legajo = parseInt(fila.legaj)
        recibo.nombre = fila.nombr
        recibo.cuil = fila.ncuil
        const fechaIngreso = moment(fila.feing, 'DD-MMM-YY', 'en', true)
        if (!fechaIngreso.isValid()) {
            throw new Error(`La fecha de ingreso del legajo ${fila.legaj} no tiene el formato esperado`)
        }
        recibo.fecha_ingreso = fechaIngreso.format('YYYY-MM-DD')
        recibo.antiguedad = fila.antiguedad
        recibo.sector = null
        recibo.funcion = null
        recibo.lugar_pago = fila.clupa
        recibo.per_dep = moment(fila.cpeul, 'MMYYYY').format('MM/YYYY')
        recibo.fecha_dep = fila.cfeul ? moment(fila.cfeul, 'DDMM').format('DD/MM') : null
        recibo.periodo_pago = moment(fila.cpepa.substr(1), 'DDYYYY').format('DD/YYYY')
        recibo.fecha_pago = moment(fila.cfepa, 'DDMMYYYY').format('YYYY-MM-DD')
        recibo.banco = fila.cbanc
        recibo.haberes_remunerativos = 0
        recibo.haberes_no_remunerativos = 0
        recibo.deducciones = 0
        recibo.neto = 0
        recibo.neto_excel = (fila.neto === '' || fila.neto == null) ? null : fila.neto
        recibo.conceptos = []
        // Costo empleador (Decreto 407/2026)
        recibo.art_unidad = fila.un_art
        recibo.art_base = fila.base_art
        recibo.art_monto = fila.mon_art
        recibo.jubilacion_unidad = fila.un_jub
        recibo.jubilacion_base = fila.base_jub
        recibo.jubilacion_monto = fila.mon_jub
        recibo.obra_social_patronal_unidad = fila.un_os
        recibo.obra_social_patronal_base = fila.base_os
        recibo.obra_social_patronal_monto = fila.mon_os
        recibo.seguro_vida_base = fila.base_segv
        recibo.seguro_vida_monto = fila.mon_segv
        recibo.subtotal_contribuciones_empleador = fila.subtotcs
        recibo.sueldo_bruto = fila.sueldobru
        recibo.costo_sindical_empleador = fila.cossine
        recibo.costo_sindical_trabajador = fila.cossint
        recibo.seguridad_social_empleador = fila.segsoce
        recibo.seguridad_social_trabajador = fila.segsoct
        recibo.obra_social_empleador = fila.ose
        recibo.obra_social_trabajador = fila.ost
        recibo.inssjp_empleador = fila.inssjpe
        recibo.inssjp_trabajador = fila.inssjpt
        recibo.costo_art_total = fila.arte
        recibo.costo_scvo_empleador = fila.cosscvoe
        recibo.contribucion_sindical_total = fila.contrsind
        const gremios = ['r1contsind', 'r2contsind', 'r3contsind', 'r4contsind', 'r5contsind', 'r6contsind', 'r7contsind']
        recibo.contribucion_sindical_detalle = gremios.some(k => fila[k])
            ? gremios.reduce((detalle, k) => { detalle[k] = fila[k]; return detalle }, {})
            : null
        recibo.texto_contribuciones_original = fila.textocontri
        return recibo
    },
    //CONCEPTOS
    findOrNewConcepto(fila, recibo) {
        // Conservar cada fila: los códigos repetidos se revisan antes de guardar.
        const concepto = {}
        concepto.codigo = parseInt(fila.codig)
        concepto.concepto = fila.descr
        concepto.cantidad = (fila.canti == 0) ? fila.porce : fila.canti
        concepto.base = (fila.base === '' || fila.base == null) ? null : fila.base
        concepto.tipo = this.tipoConcepto(fila.importe, fila._ncol, fila.toimp)
        concepto.importe = (concepto.tipo == 'deduccion') ? fila.importe * -1 : fila.importe
        this.calcularHaberes(recibo, concepto)
        recibo.conceptos.push(concepto)
    },
    tipoConcepto(importe, ncol, toimp) {
        const t = (toimp || '').toUpperCase()
        if (t.includes('RETEN'))
            return 'deduccion'
        if (t.includes('ASIGNACION'))
            return 'no_remunerativo'
        if (t.includes('REMSINDES'))
            return 'no_remunerativo'
        if (t.includes('REMCONDES'))
            return 'remunerativo'
        if (ncol == 3)
            return 'deduccion'
        if (ncol == 1)
            return 'remunerativo'
        return 'no_remunerativo'
    },
    calcularHaberes(recibo, concepto) {
        switch (concepto.tipo) {
            case 'remunerativo':
                recibo.haberes_remunerativos += concepto.importe
                recibo.neto += concepto.importe
                break
            case 'no_remunerativo':
                recibo.haberes_no_remunerativos += concepto.importe
                recibo.neto += concepto.importe
                break
            case 'deduccion':
                recibo.deducciones += concepto.importe
                recibo.neto -= concepto.importe
                break
            default:
                break
        }
    },
    numberFormat(val) {
        const options2 = { style: 'currency', currency: 'USD' };
        const numberFormat = new Intl.NumberFormat('en-US', options2);
        return numberFormat.format(val)
    },
    tiposLiquidacion: [{
            "Id": "0",
            "Periodo": "Mensual"
        },
        {
            "Id": "1",
            "Periodo": "Primera Quincena"
        },
        {
            "Id": "2",
            "Periodo": "Segunda Quincena"
        },
        {
            "Id": "3",
            "Periodo": "Aguinaldo"
        },
        {
            "Id": "4",
            "Periodo": "Vacaciones"
        },
        {
            "Id": "5",
            "Periodo": "Adelanto"
        },
        {
            "Id": "8",
            "Periodo": "Calculo auxiliar base fija vacaciones"
        },
        {
            "Id": "9",
            "Periodo": "Liquidacion final"
        }
    ]
}
